<template>
  <!--<div v-if="display">-->
  <div>
    <modal-layout-top :title="title" />
    <div class="slider-modal">
      <invoice-preview
        :data="invoice"
        :logo-url="logoUrl"
        @closePanel="closePanel()"
        @save="save()" />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import InvoicePreview from '@/components/pages/Admin/Invoices/InvoicePreview'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'

export default {
  name: 'invoice-review-modal',
  components: {
    InvoicePreview,
    ModalLayoutTop
  },

  data () {
    return {
      invoice: null,
      logoUrl: null,
      display: false
    }
  },

  computed: {
    title () {
      return this.invoice ? `Granska faktura för ${this.invoice.projectCode}` : null
    }
  },

  props: {
    projectId: {
      type: Number,
      required: false
    },
    invoiceId: {
      type: Number,
      required: false
    }
  },

  methods: {
    ...mapActions('invoicesOwner', ['createPreviewFromProjectId', 'createFromProjectId', 'createCreditInvoicePreview', 'createCreditInvoice']),
    ...mapActions('workOrders', ['containsStatusStarted']),
    closePanel () {
      this.$emit('closePanel', {
        data: null
      })
    },

    save () {
      if (this.invoice.invoiceType === 'Credit') {
        this.$confirm('Skapa kreditfaktura?').then((result) => {
          if (result.value) {
            this.$store.state.loading = true
            this.createCreditInvoice(this.invoiceId).then(() => {
              this.$store.state.loading = false
              this.closePanel()
            })
          }
        })
      } else {
        // If there are WOs that are started, display a different popup
        this.containsStatusStarted(this.projectId).then(containsStatusStarted => {
          if (containsStatusStarted) {
            const options = {
              title: 'Skapa faktura?',
              // html: 'Det finns insatser med status Påbörjad i projektet' +
              // '<br>' +
              // '<button type="button" role="button" tabindex="0" class="SwalBtn1 customSwalBtn">' + 'Button1' + '</button>'
              text: 'Det finns påbörjade insatser i projektet. Vill du skapa faktura ändå?',
              confirmButtonText: 'Ja',
              cancelButtonText: 'Avbryt',
              showCancelButton: true,
              footer: '<a id="go-to-work-orders">Gå till insatser</a>'
            }

            this.$alert(options).then((result) => {
              if (result.value) {
                this.$store.state.loading = true
                this.createFromProjectId(this.projectId).then(() => {
                  this.$store.state.loading = false
                  this.closePanel()
                })
              }
            })

            // Add event listender for work orders link
            const that = this
            setTimeout(() => {
              const workOrdersButton = document.getElementById('go-to-work-orders')
              workOrdersButton.addEventListener('click', function () {
                that.$closeAlert()
                that.closePanel()
                that.$router.push({ name: 'Project_WorkOrders', params: { projectCode: that.invoice.projectCode } })
              })
            }, 200)
          } else {
            this.$confirm('Skapa faktura?').then((result) => {
              if (result.value) {
                this.$store.state.loading = true
                this.createFromProjectId(this.projectId).then(() => {
                  this.$store.state.loading = false
                  this.closePanel()
                })
              }
            })
          }
        })
      }
    }
  },

  created () {
    if (!this.projectId && !this.invoiceId) {
      this.$toast('Inget ID angivet', 'error')
    }

    if (this.projectId) {
      this.createPreviewFromProjectId(this.projectId).then((data) => {
        this.invoice = data.invoiceDto
        this.logoUrl = data.logoUrl
        this.display = true
      })
    } else {
      this.createCreditInvoicePreview(this.invoiceId).then((data) => {
        this.invoice = data.invoiceDto
        this.logoUrl = data.logoUrl
        this.display = true
      })
    }
  }
}
</script>

<style>
#invoice-html {
  width: 80%;
  height: 1650px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/InvoicePreviewModal.vue